import gsap from "gsap";

export default function pageLoading() {
  /***********************************************************************
   * 変数定義
   ***********************************************************************/
  const wrapper = document.querySelector('.loading_wrapper');
  const mask = document.querySelector('.loading_mask');
  const linkEls = [
    ...document.querySelectorAll('a:not([href*="#"]):not([href*="tel:"]):not([target])'),
  ];
  const currentHostName = window.location.hostname;
  const enterTime = 1.5; // ページ読み込み時のアニメーションの時間 単位：秒
  const leaveTime = 1; // ページ離脱時のアニメーション 単位：秒

  const tl = gsap.timeline();

  /***********************************************************************
   * ページ読み込み時のアニメーション
   ***********************************************************************/
  gsap.set(wrapper, { autoAlpha: 1 });
  tl.to(mask, {
    autoAlpha: 0,
    duration: enterTime,
  }).to(
    wrapper,
    {
      autoAlpha: 1,
      duration: enterTime,
    },
    '<', // 直前のtoと同時にアニメーションスタート
  );

  /***********************************************************************
   * ページ離脱時のアニメーション
   ***********************************************************************/
  const loadingAnimation = (url) => {
    tl.to(mask, {
      autoAlpha: 1,
      duration: leaveTime,
    }).to(
      wrapper,
      {
        autoAlpha: 0,
        duration: leaveTime,
      },
      '<',
    );

    // ページ遷移処理
    setTimeout(() => {
      window.location = url;
    }, leaveTime * 1000);
  };

  /***********************************************************************
   * リンク click 時の処理
   ***********************************************************************/
  // setTimeoutのdelayはbaseのwrapper::afterのtransitionと合わせる
  linkEls.forEach((linkEl) => {
    linkEl.addEventListener(
      'click',
      (e) => {
        // command or control+クリックのときは処理しない
        if ((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey)) return;

        e.preventDefault(); // cancel navigate
        e.stopPropagation(); // menuなどに伝搬されて挙動が変わる場合があるので防止
        const url = linkEl.getAttribute('href');
        if (url === null) return;
        if (url !== '' && url.indexOf(currentHostName)) {
          loadingAnimation(url);
        }
      },
      false,
    );
  });

  // SafariでブラウザバックするとJSなどが解除されていない問題【bfcache】の対策
  // 強制リロード
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      // bfcache発動時の処理
      window.location.reload();
    }
  });
}
